import { render } from "./ButtonBrutal.vue?vue&type=template&id=3171bc2e"
import script from "./ButtonBrutal.vue?vue&type=script&lang=js"
export * from "./ButtonBrutal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__